<div class="d-flex h-100">
  <div class="h-100 d-flex flex-column">
    <a class="navbar-icon" href="#"><img *ngIf="!opened" src="assets/images/Deloitte_logo_small.png" alt="logo" /><img *ngIf="opened" class="logo-left" src="assets/images/Deloitte_logo_large.png" alt="logo" /></a>
    <nav class="navbar navbar-vertical align-items-baseline flex-nowrap bg-light" [class.navbar-opened]="opened">
      <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <ul #menuList class="navbar-nav mr-auto h-100" >
        <li class="nav-item">
          <a class="nav-link" (click)="toggleMenu()"><i *ngIf="!opened" class="fas fa-bars nav-link-icon"></i><i *ngIf="opened" class="fas fa-angle-double-left nav-link-icon"></i></a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/home']" (click)="closeMenu()"><i class="fas fa-home nav-link-icon"></i> <span class="nav-link-text">Home</span></a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/submissions/overview']" (click)="closeMenu()"><i class="fas fa-file-invoice nav-link-icon"></i> <span class="nav-link-text">Submissions</span></a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/submissions/efile-overview']" (click)="closeMenu()"><i class="fas fa-file-upload nav-link-icon"></i> <span class="nav-link-text">eFile Upload</span></a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/company-structure/company-management']" (click)="closeMenu()"> <i class="fas fa-building nav-link-icon"></i> <span class="nav-link-text">Company</span></a>
        </li>
        <li  class="nav-item mt-auto">

        </li>
        <li class="nav-item" [routerLinkActive]="['active']" *showPermitted="permission.AdminPages">
          <a class="nav-link" [routerLink]="['/administration']" (click)="closeMenu()"><i class="fas fa-user-cog nav-link-icon"></i> <span class="nav-link-text">Admin</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" target="_blank" href="https://be-deloitte-gtc.itrp.com/self-service/requests/new/select_service_instance?from=wizard&requested_for_id=&requestor_id=&service_id=36731&support_domain=be-deloitte-gtc" rel="noopener noreferrer"><i class="far fa-question-circle nav-link-icon"></i> <span class="nav-link-text">Help</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link cursor-pointer" #privacyAndLegalLink (click)="showContextMenu(privacyAndLegalMenu, privacyAndLegalLink, menuList)"><i class="fas fa-balance-scale nav-link-icon"></i> <span class="nav-link-text">Privacy & Legal</span></a>
          <kendo-contextmenu #privacyAndLegalMenu showOn="click" (select)="onSelectContextItme($event)"> 
            <ng-template kendoContextMenuTemplate>
              <div class="context-menu-dark">
                <p class="mb-0"><i class="far fa-copyright"></i> {{currentYear}}</p>
                <p>Version 1.0</p>
                <p><a target="_blank" href="https://www2.deloitte.com/be/en/legal/acceptable-usage-policy.html" title="Acceptable Use Policy" rel="noopener noreferrer">Acceptable Use Policy</a></p>
                <p><a [routerLink]="['/privacy']" title="Privacy">Privacy</a></p>
                <p><a [routerLink]="['/terms-of-use']" title="Terms of use">Terms of use</a></p>
                <p><a [routerLink]="['/oss-copyright']" title="OSS Copyright">OSS Copyright</a></p>
                <p class="mb-0"><a target="_blank" href="https://www.deloitte.com/about" title="About Deloitte" rel="noopener noreferrer">About Deloitte</a></p>
                <p class="p-link mt-3"><a class="optanon-toggle-display" title="View Cookies">View Cookies</a></p>
              </div>
            </ng-template>
          </kendo-contextmenu>
        </li>
      </ul>
      
    </nav>
  </div>
  <div class="d-flex flex-column flex-grow-1">
    <nav class="navbar navbar-expand-lg bg-dark">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <spv2-back-navigation-header></spv2-back-navigation-header>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" *ngIf="!settings.production">
            <a class="nav-link" (click)="tempRemoveApplicationPermissions()"><i class="fas fa-user-secret nav-link-icon click-interaction"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="logout()"><i class="fas fa-sign-out-alt nav-link-icon click-interaction"></i></a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="page-navbar-wrapper">
      <spv2-alert-banner class="h-inherit"></spv2-alert-banner>
      <spv2-breadcrumb></spv2-breadcrumb>
    </div>
    <div class="banner" role="alert" *ngIf="showNoAccessBanner">
      <strong class="mr-5" ><i class="fas fa-user-lock mr-3"></i>NO COMPANY ACCESS</strong>
      <span>Please contact the Company Administrator or click on the link to request access. For more information refer to the ‘Help’ section. </span>
      <a class="ml-5" target="_blank" href="https://be-deloitte-gtc.itrp.com/self-service/requests/new/provide_description?from=wizard&requested_for_id=&requestor_id=&service_id=36731&service_instance_id=172468&support_domain=be-deloitte-gtc&template_id=103954" rel="noopener noreferrer">REQUEST ACCESS</a>
      <strong class="float-right" (click)="showNoAccessBanner = false"><i class="fas fa-times"></i></strong>
    </div>
    <div class="container-fluid bg-light h-100 overflow-y-scroll">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>